import { render } from "./DivisionPlanClimateGraphsComponent.vue?vue&type=template&id=bf940084"
import script from "./DivisionPlanClimateGraphsComponent.vue?vue&type=script&lang=js"
export * from "./DivisionPlanClimateGraphsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__